<template>
  <div class="mainbody">
   		<div class="headers">
   				<div class="bannerNote">老年人办事服务专区</div>
   		</div>
   		<div class="body_one">
   			<div class="outerdiv">
   				
   				<div class="body_one_listtable">
   					
   					<div class="body_one_listtable_one"  v-for="(item, index) in datarr" :key="index">
							<div class="body_one_listtable_one_l" >
								 {{item.ITEM_NAME}} 
							</div>
							<div class="body_one_listtable_one_r" @click="open(item.PC_LINK)">
							 在线办理
							</div>
						</div>
						<div class="body_one_pageturn">
   					<el-pagination background  layout="total, prev, pager, next, jumper" :total="total"   @current-change="handleCurrentChange"></el-pagination>
   				</div>
   				</div>
   		</div>
   		</div>
   		
   		
   		<!--<div class="contentMap">
      <div class="contentMaptop">
         <div class="contentMaptopleft">
            政务地图，便捷指引
         </div>
         <div class="contentMaptopright"></div>
      </div>
      <div class="contentMaptopline"></div>
      <div class="contentMapcontent">
         <div class="contentMapcontentleft">

            <div class="contentMapcontentlefttop">
               <div class="contentMapcontentlefttoptitle">大庆市</div>
               <div class="contentMapcontentlefttopright">共{{ list.length }}个线下政务网点</div>
            </div>
            <div class="contentMapcontentleftarr">
               <div v-for="(item, index) in list" :key="index" @click="changeditu(item)">
                  <div class="contentMapcontentleftarrfor">
                     <div class="contentMapcontentleftarrfortop">
                        <div class="contentMapcontentleftarrfortopindex">{{ index + 1 }}</div>
                        <div class="contentMapcontentleftarrfortopname">{{ item.alias }}</div>
                     </div>
                     <div class="contentMapcontentleftarrfortopaddress" style="margin-top: 20px;">
                        <div class="contentMapcontentleftarrfortopaddressleft"></div>
                        <div class="listarrlefttoparrcontentaddressdetailaddressright">{{ item.detail }}</div>
                     </div>
                     <div class="contentMapcontentleftarrfortopphone" style="margin-top: 20px;">
                        <div class="contentMapcontentleftarrfortopphoneleft"></div>
                        <div class="contentMapcontentleftarrfortopphoneright">{{ item.phone }}</div>
                     </div>
                     <div class="contentMapcontentleftarrfortoptime">
                        <div class="contentMapcontentleftarrfortoptimeleft"></div>
                        <div class="contentMapcontentleftarrfortoptimeright">上午8:30-11:30、下午13:30-16:50 周末双休</div>
                     </div>
                     <div class="contentMapcontentleftarrforbottomline"></div>
                  </div>
               </div>
            </div>
         </div>
         <div class="contentMapcontentright">
            <el-amap :zoom="zoom" :center="center" class="amap-demo">
               <el-amap-marker :position="componentMarker.position" :offset="componentMarker.offset"
                  :visible="componentMarker.visible" @click="clickMarker">
                  <div class="markercontent">
                     <div class="markercontenttitle" style="margin-top: 7px;margin-left: 5px">
                        <div class="markercontenttitleleft" style="width:140px;   overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;">{{ componentMarker.text }}</div>
                        <div class="markercontenttitlerighted">X</div>
                     </div>
                     <div class="markercontenttitle" style="margin-top: 2px;margin-left: 5px">
                        <div class="markercontenttitleleft" style="color:black">电话:</div>
                        <div class="markercontenttitleright">{{ componentMarker.phone }}</div>
                     </div>
                     <div class="markercontenttitle" style="margin-top: 2px;margin-left: 5px">
                        <div class="markercontenttitleleft" style="color:black">地址:</div>
                        <div class="markercontenttitleright">{{ componentMarker.address }}</div>
                     </div>
                  </div>
               </el-amap-marker>
               <el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position"
                  @click="(e) => { clickArrayMarker(marker, e) }" :icon="marker.icon"
                  :offset="marker.offset"></el-amap-marker>
            </el-amap>
         </div>
      </div>

   </div>	
   -->
   	<div class="contentNew">
        <div class="contentNewtop">
            <div class="contentNewtoptopleft">
                全市动态早知晓
            </div>
            <div class="contentNewtopright"></div>
        </div>
        <div class="contentNewtopline"></div>
        <div class="contentNewcontent">
            <div class="contentNewcontentleft">
                <img :src="newsfirst.IMG_URL" class="contentNewcontentleftimg">
                <div class="contentNewcontentleftbottom" @click="openview(newsfirst.SEQ)">
                    <div class="contentNewcontentleftbottomtop">
                    	
                        <div class="contentNewcontentleftbottomtoptitle">{{newsfirst.TITLE}}</div>
                        <div class="contentNewcontentleftbottomtoptitletwo">
                           {{newsfirst.DESC}}</div>
                    </div>
                    <div class="contentNewcontentleftbottomline"></div>
                    <div class="contentNewpcontentleftbottombottom">
                        <div class="contentNewcontentleftbottombottomleft">{{newsfirst.SHOW_TIME}}</div>
                        <div class="contentNewpcontentleftbottombottomright">
                            <div class="contentNewcontentleftbottombottomrightimg"></div>
                            <div class="contentNewpcontentleftbottombottomrightimgtwo"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="contentNewcontentright">
                <div class="contentNewpcontentrighttop">
                    <div v-for="(item, index) in listtwo" :key="index">
                        <div class="contentNewpcontentrighttopfor" @click="openview(item.SEQ)">
                            <div class="contentNewcontentrighttopforleft">
                                <div class="contentNewcontentrighttopforleftdata">{{item.SHOW_TIME.substring(5,10)}}</div>
                                <div class="contentNewcontentrighttopforleftdatayear">{{item.SHOW_TIME.substring(0,4)}}</div>
                            </div>
                            <div class="contentNewcontentrighttopmiddleline"></div>
                            <div class="contentNewcontentrighttopforright">
                                <div class="contentNewcontentrighttopforrighttitle">{{item.TITLE}}</div>
                                <div class="contentNewcontentrighttopforrighttitletwo">
                                    {{item.DESC}}</div>
                            </div>

                        </div>
                        <div class="contentNewpcontentrighttopforline"></div>
                    </div>

                </div>
                <div class="contentNewcontentrightturn">
                    <el-pagination  layout="total, prev, pager, next" :total="newstotal" :page-size="newspageSize" @current-change="handleCurrentChangenews" background>
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
    
    	<div class="contentCommit">
        <div class="contentCommittop">
            <div class="contentCommittopleft">
                交流互动
            </div>
            <div class="contentCommittopright"></div>
        </div>
        <div class="contentCommittoprighttopline"></div>
        <div class="contentCommittcontent">
            <swiper :options="swiperOption" ref="mySwiper">

                <swiper-slide v-for="(item, index) in navelist" :key="index" class="navelistlistarr" :style="{
                    'background-image': `url(${require('@/assets/' +
                        item.background +
                        '.png')})`,
                }">
                    <div class="navelistlistfor" @click="goto(item)">
                        <div class="navelistlistfortoptitle" :style="{ color: item.color }">{{ item.title }}</div>
                        <div class="navelistlistfortoptitled" :style="{ color: item.color }">{{ item.content }}</div>
                        <div class="navelistlistfortoptitthree" :style="{ color: item.color }">{{ item.buttonTitle }}</div>
                    </div>

                </swiper-slide>

            </swiper>

        </div>

    </div> 		

  </div>
</template>

<script>
import{ getList,createSign ,gateWay}from "@/api/ssbs";

export default {
	  data() {
    return {
				 // 当前颜色
	      currentIndex: 0,
	      currentvalue:"999",
	        total:10,
	      itemName:"",
	      jbxx:"",
	      pageSize:10,
	      pageNum:1,
	      searchkey:"",
	      datarr:[],
			  navelist:[
				  {
				  	title:"公积金管理",
				  	value:"1"
				  },{
				  	title:"公积金管理",
				  	value:"1"
				  },{
				  	title:"公积金管理",
				  	value:"1"
				  },{
				  	title:"公积金管理",
				  	value:"1"
				  },{
				  	title:"公积金管理",
				  	value:"1"
				  },{
				  	title:"公积金管理",
				  	value:"1"
				  },{
				  	title:"公积金管理",
				  	value:"1"
				  }
				  ],
				  datarr:[{
				  	title:" 国务院办公厅关于进一步优化营商环境更好服务市场主体的实施意见国办发〔2020〕24号 ",
				  	time:"2023-10-31"
				  },{
				  	title:" 国务院办公厅关于进一步优化营商环境更好服务市场主体的实施意见国办发〔2020〕24号 ",
				  	time:"2023-10-31"
				  },{
				  	title:" 国务院办公厅关于进一步优化营商环境更好服务市场主体的实施意见国办发〔2020〕24号 ",
				  	time:"2023-10-31"
				  },{
				  	title:" 国务院办公厅关于进一步优化营商环境更好服务市场主体的实施意见国办发〔2020〕24号 ",
				  	time:"2023-10-31"
				  },{
				  	title:" 国务院办公厅关于进一步优化营商环境更好服务市场主体的实施意见国办发〔2020〕24号 ",
				  	time:"2023-10-31"
				  },{
				  	title:" 国务院办公厅关于进一步优化营商环境更好服务市场主体的实施意见国办发〔2020〕24号 ",
				  	time:"2023-10-31"
				  },{
				  	title:" 国务院办公厅关于进一步优化营商环境更好服务市场主体的实施意见国办发〔2020〕24号 ",
				  	time:"2023-10-31"
				  },{
				  	title:" 国务院办公厅关于进一步优化营商环境更好服务市场主体的实施意见国办发〔2020〕24号 ",
				  	time:"2023-10-31"
				  },{
				  	title:" 国务院办公厅关于进一步优化营商环境更好服务市场主体的实施意见国办发〔2020〕24号 ",
				  	time:"2023-10-31"
				  },{
				  	title:" 国务院办公厅关于进一步优化营商环境更好服务市场主体的实施意见国办发〔2020〕24号 ",
				  	time:"2023-10-31"
				  }],
				   list: [{
            "alias": "大庆高新区公共服务中心",
            "centerLevel": "0-1-2",
            "distance": 0.27533726526380636,
            "lat": 125.15,
            "lng": 46.58,
            "orderId": 11,
            "pinyin": "D",
            "seq": "9c40efbac161428d9d70315552a5560e",
            "detail": '大庆高新区火炬新街46号',
            'phone': '0459-6052111'
         },
         {
            "alias": "大庆市龙凤区政务服务中心",
            "centerLevel": "0-1-2",
            "distance": 2.445875930463023,
            "lat": 125.134903,
            "lng": 46.563048,
            "orderId": 7,
            "pinyin": "D",
            "seq": "c12a977f3ecf4c69adeeab9beaff5de3",
            "detail": '龙凤区政务服中心(龙凤区政府对面)龙政路2-3号',
            'phone': '0459-6216100'
         },
         {
            "alias": "大庆市政务服务中心",
            "centerLevel": "0-1-2",
            "distance": 4.013944739822683,
            "lat": 125.102424,
            "lng": 46.589909,
            "orderId": 2,
            "pinyin": "D",
            "seq": "e2b2fe537a7b4af3be86e772f9777d2a",
            "detail": '大庆市东风新村(萨尔图区) 政西街2号市政务服务中心',
            'phone': '0459-6158890'
         },
         {
            "alias": "大庆市萨尔图区政务服务中心",
            "centerLevel": "0-1-2",
            "distance": 5.4741920060623706,
            "lat": 125.138385,
            "lng": 46.629128,
            "orderId": 5,
            "pinyin": "D",
            "seq": "41ff73b5c2724759a8dda53525e101db",
            "detail": '大庆市萨尔区萨政路6号萨尔图区政务服务中心',
            'phone': '0459-4608611'
         },
         {
            "alias": "大庆市让胡路区政务服务中心",
            "centerLevel": "0-1-2",
            "distance": 18.84981553006496,
            "lat": 124.908131,
            "lng": 46.598116,
            "orderId": 10,
            "pinyin": "D",
            "seq": "e9d7719044414f8b86d8a8e445e3da4e",
            "detail": '大庆市让胡路区新城街287号 (房产交易中心南侧)',
            'phone': '0459-5152787'
         },
         {
            "alias": "大庆市红岗区政务服务中心",
            "centerLevel": "0-1-2",
            "distance": 28.723403324769794,
            "lat": 124.88953,
            "lng": 46.397711,
            "orderId": 1,
            "pinyin": "D",
            "seq": "ecc55616a0084264b9f5b77061a87dcc",
            "detail": '大庆市红岗萨大中路南22号红岗区政务服务中心',
            'phone': '0459-4197337'
         },
         {
            "alias": "大庆市杜蒙县政务服务中心",
            "centerLevel": "0-1-2",
            "distance": 61.83306839182406,
            "lat": 124.454682,
            "lng": 46.862411,
            "orderId": 2,
            "pinyin": "D",
            "seq": "bd166da8d5554973b015e0ae2b836286",
            "detail": '杜尔伯特蒙古族自治县塔拉街杜尔伯特蒙古族自治县政务服务中心(原地税局)',
            'phone': '0459-3410837'
         },
         {
            "alias": "大庆市大同区政务服务中心",
            "centerLevel": "0-1-2",
            "distance": 65.6610970529878,
            "lat": 124.814734,
            "lng": 46.039518,
            "orderId": 4,
            "pinyin": "D",
            "seq": "dd77f40721644d719ee7ebcc47f9e28c",
            "detail": '大同区同城路93号大同区政务服务中心 (区政府一层)',
            'phone': '0459-6165969'
         },
         {
            "alias": "大庆市林甸县政务服务中心",
            "centerLevel": "0-1-2",
            "distance": 69.29759088638323,
            "lat": 124.878208,
            "lng": 47.174466,
            "orderId": 9,
            "pinyin": "D",
            "seq": "d712657013444e6da52c93ccf06e3659",
            "detail": '林甸县丽水华庭小区二期综合楼林甸县政务服务中心',
            'phone': '0459-3319551'
         },
         {
            "alias": "大庆市肇州县政务服务中心",
            "centerLevel": "0-1-2",
            "distance": 97.58878535840806,
            "lat": 125.259796,
            "lng": 45.707485,
            "orderId": 3,
            "pinyin": "D",
            "seq": "7e22bad5d26542caa9f7a106c69b8090",
            "detail": '八场街354号肇州县政务服务中心',
            'phone': '0459-8532513'
         },
         {
            "alias": "大庆市肇源县政务服务中心",
            "centerLevel": "0-1-2",
            "distance": 117.18486157790682,
            "lat": 125.092844,
            "lng": 45.529174,
            "orderId": 6,
            "pinyin": "D",
            "seq": "be12d99b4d7b448eabfb919907bd6520",
            "detail": '肇源县G203(明沈)郭尔罗斯大街207号肇源县政务服务中心',
            'phone': '0459-8333207'
         }
         ],
         zoom: 16,
         center: ['125.15', '46.58'],

         markers: [],
         componentMarker: {},
         
         
       swiperOption: {
                // loop: true,
                slidesPerView: 'auto',
                spaceBetween: 30,
                autoplay: {

                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },

            },
            navelist: [{ 'background': 'backgroundone', 'title': '投诉建议', content: '您对政务服务有任何意见建议，可及时反馈给我们', 'buttonTitle': '我要提问', color: '#653738',url:' https://www.zwfw.hlj.gov.cn/zhcx/jact/notice?type=ts&areaCode=230600000000' },
            { 'background': 'backgroundtwo', 'title': '办件查询', content: '您对事项或案件的办理进度或结果进行查询', 'buttonTitle': '我要查询', color: '#45597D',url:' https://www.zwfw.hlj.gov.cn/yhkj/Myoffice/MyProgress' },
            { 'background': 'backgroundthree', 'title': '好差评', content: '敬请评价政务服务工作并提出宝贵的意见和建议', 'buttonTitle': '我要查看', color: '#6D4A41',url:'https://www.zwfw.hlj.gov.cn/zhcx/hcp?areaCode=230600000000' },
//          { 'background': 'backgroundfour', 'title': '使用指引', content: '按照步骤操作，遇到问题可查看注意事项或寻求帮助', 'buttonTitle': '我要查看', color: '#218865' },    
            { 'background': 'backgroundfive', 'title': '我要咨询', content: '想了解的业务都可以来这儿问，7x24小时为您解答', 'buttonTitle': '我要提问', color: '#00227C',url:' https://www.zwfw.hlj.gov.cn/hljznkf/home?areacode=230600000000' }],
            
            
            newslist: [],
            newsfirst:{},
            listtwo:[],
            newstotal:10,
            newspageSize:4,
            newspageNum:1,
    };
  },
    created() {
 			this.getmark()
  	},
	  mounted() {
			this.getList();
			this.getnewsList();
	  },
  	methods: {
  	 changeColor(index,values) {
    	console.log(values)
      this.currentIndex = index;
      this.currentvalue=values;
    },handleCurrentChange(val) {
     		console.log(val)
     		this.pageNum = val;
     		this.getList();
    	},checkout(){
    		
    	},async getList(){
    		var that=this;
    		// // 加密
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 0; // 1 - C1C3C2，0 - C1C2C3，默认为1
      let pbk =
        "042B927AA7D977B87FB0491CCF4BB14966B443B32CDC8AF1F72E4E21C256E36846B35B8A3DDFCDC6ECCF86DF9728E5D1B6E8340BE4AF7167634E07850E898797E5";
      let jmContent =
        "04" +
        sm2.doEncrypt(
          `{
          pageSize: ${that.pageSize},
          pageNum: ${that.pageNum},
       		floorSeq: "09CB6E98804B552EE0630100007F048C"
        }`,
          pbk,
          cipherMode
        ); // 加密结果
        	console.log( `{
          pageSize: ${that.pageSize},
          pageNum: ${that.pageNum},
       		floorSeq: "09CB6E98804B552EE0630100007F048C"
        }`)
      console.log("加密", jmContent);
//    let datajson={
//			   			paramSm2: jmpassword,
//			   		}

						var datajsons=
	    	 		  {
					    app_id: "lnrfwzqPCmfcwi",
					    interface_id: "92a74cd61gthu56gf7c8881de183a",
					    version: "1.0",
					   	header: {},
					    biz_content: JSON.stringify({
				      paramSm2: jmContent
				    	}),
					    charset: "UTF-8",
					    timestamp: "1697679274192",
					    origin: 1
				  	}
	    	 		
			    	 let res= await createSign(datajsons);
			    	 var sign="";
			    	 
			    	 if (res.status == 200) {
				  		if (res.data.success) {
				    		sign = res.data.data.sign;
				  		}
						}

						 var datajsonss=
	    	 		  {
					    app_id: "lnrfwzqPCmfcwi",
					    interface_id: "92a74cd61gthu56gf7c8881de183a",
					    version: "1.0",
					   	header: {},
					    biz_content: JSON.stringify({
				      paramSm2: jmContent
				    	}),
					    charset: "UTF-8",
					    timestamp: "1697679274192",
					    origin: 1,
					    sign:sign,
				  	}
	    	 		   let ress= await gateWay(datajsonss);
	    	 		   
	    	 		   if (ress.status == 200) {
				 			 if (ress.data.success) {
				 			 			
				 			 			 let realData = JSON.parse(ress.data.data);
									    console.log("转成json", realData);
									    // 解密
									    
									    var doDecrypt = sm2.doDecrypt(
						            realData.data.substr(2),
						            "009B23E6AD2E020563EF328232ECB505EDD18CD2E58CDF8851BC4AF034A687F12C",
						            0
						          );
						          let data = JSON.parse(doDecrypt);
									    	 console.log(data)
									    	 	  
									     if(data.data.pageInfo.list==""||data.data.pageInfo.list==undefined){
									    	 	   		that.$message({
                      
                        dangerouslyUseHTMLString: true,
                        iconClass:'myicon',
                        message: '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 10px;margin-top: 6px;font-weight:bold">暂无数据！</div>'
                    });
									    	 	   }else{
									    	 	   		   that.total = data.data.pageInfo.total;
											that.datarr = data.data.pageInfo.list;
									    	 	   }	 	  
									    	 	  
									   
				 			 	}
				 			 }
						
//
//			    	 let res= await getList(datajson);
//			    	 
//			    	 console.log(res);
//			    	 
//			    	 var doDecrypt = sm2.doDecrypt(
//          res.data.data.substr(2),
//          "009B23E6AD2E020563EF328232ECB505EDD18CD2E58CDF8851BC4AF034A687F12C",
//          0
//        );
//        let data = JSON.parse(doDecrypt);
//        console.log(data)
//
//        that.total = data.data.pageInfo.total;
//        that.datarr = data.data.pageInfo.list;
           
    		
    		
    	},open(url){
			window.open(url, '_blank')
  		}
    	
    	//高德地图
			,getmark() {
         this.zoom = 16
         this.center = [this.list[0].lat, this.list[0].lng]
         this.markers.push({
            offset: [0, -20],
            position: [this.list[0].lat, this.list[0].lng],
            icon: require("@/assets/icon.png"),

         })
         this.componentMarker = {
            position: [this.list[0].lat, this.list[0].lng],
            visible: true,
            draggable: false,
            text: this.list[0].alias,
            phone: this.list[0].phone,
            address: this.list[0].detail,
            offset: [-80, -110]
         }
      },
      changeditu(item) {
         console.log(item)
         this.center = [item.lat, item.lng]
         this.markers[0].position = [item.lat, item.lng]
         this.componentMarker.position = [item.lat, item.lng]
         this.componentMarker.text = item.alias
         this.componentMarker.phone = item.phone
         this.componentMarker.address = item.detail
      },
      clickMarker() {
         this.componentMarker.visible = !this.componentMarker.visible;
      },
      clickArrayMarker() {
         this.componentMarker.visible = !this.componentMarker.visible;
      },
      
      //交流互动
       goto(item) {
        if(item.title=='使用指引'){
          this.dialogShow=true
        }else{
            window.open(item.url)
        }
    	},
    	async getnewsList(){
    		
    		var that=this;
    		// // 加密
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 0; // 1 - C1C3C2，0 - C1C2C3，默认为1
      let pbk =
        "042B927AA7D977B87FB0491CCF4BB14966B443B32CDC8AF1F72E4E21C256E36846B35B8A3DDFCDC6ECCF86DF9728E5D1B6E8340BE4AF7167634E07850E898797E5";
      let jmContent =
        "04" +
        sm2.doEncrypt(
          `{
          pageSize: 999,
          pageNum: ${that.newspageNum},
       		floorSeq: "0A7D46C0F9C21B47E0630100007FFB3E"
        }`,
          pbk,
          cipherMode
        ); // 加密结果
        	console.log( `{
          pageSize: 999,
          pageNum: ${that.newspageNum},
       		floorSeq: "0A7D46C0F9C21B47E0630100007FFB3E"
        }`)
      console.log("加密", jmContent);

						var datajsons=
	    	 		  {
					    app_id: "lnrfwzqPCmfcwi",
					    interface_id: "92a756ffjhvvgfgj67b02f7c8881de183a",
					    version: "1.0",
					   	header: {},
					    biz_content: JSON.stringify({
				      paramSm2: jmContent
				    	}),
					    charset: "UTF-8",
					    timestamp: "1697679274192",
					    origin: 1
				  	}
	    	 		
			    	 let res= await createSign(datajsons);
			    	 var sign="";
			    	 
			    	 if (res.status == 200) {
				  		if (res.data.success) {
				    		sign = res.data.data.sign;
				  		}
						}

						 var datajsonss=
	    	 		  {
					      app_id: "lnrfwzqPCmfcwi",
					    interface_id: "92a756ffjhvvgfgj67b02f7c8881de183a",
					    version: "1.0",
					   	header: {},
					    biz_content: JSON.stringify({
				      paramSm2: jmContent
				    	}),
					    charset: "UTF-8",
					    timestamp: "1697679274192",
					    origin: 1,
					    sign:sign,
				  	}
	    	 		   let ress= await gateWay(datajsonss);
	    	 		   
	    	 		   if (ress.status == 200) {
				 			 if (ress.data.success) {
				 			 			
				 			 			 let realData = JSON.parse(ress.data.data);
									    console.log("转成json", realData);
									    // 解密
									    
									    var doDecrypt = sm2.doDecrypt(
						            realData.data.substr(2),
						            "009B23E6AD2E020563EF328232ECB505EDD18CD2E58CDF8851BC4AF034A687F12C",
						            0
						          );
						          let data = JSON.parse(doDecrypt);
									    	 console.log(data)
									    	 	  
									     if(data.data.pageInfo.list==""||data.data.pageInfo.list==undefined){
									    	 	   		that.$message({
                      
                        dangerouslyUseHTMLString: true,
                        iconClass:'myicon',
                        message: '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 10px;margin-top: 6px;font-weight:bold">暂无数据！</div>'
                    });
									    	 	   }else{
									    	 	   		   that.newstotal = data.data.pageInfo.total;
																	 that.newslist = data.data.pageInfo.list;
																	 that.newsfirst=data.data.pageInfo.list[0];
																	  that.handleCurrentChangenews(1);
									    	 	   }	 	  
									    	 	  
									   
				 			 	}
				 			 }
    },handleCurrentChangenews(val) {
				console.log(123123)
         const newFoo = structuredClone(this.newslist);
         this.listtwo = newFoo.slice((val - 1) * 4 + 1, val * 4 + 1)	
 
    	},openview(val){
  		this.$router.push({ path: "/about", query: { seq: val } });
    	}
  }
}
</script>
<style scoped>
* {
        margin: 0;
        padding: 0;
        color: #101010;
      }
.mainbody{
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.headers{
		width: 100%;
    height: 300px;
    margin: 0 auto;
    background-image: url(../assets/beijing.png);
    background-size: 100% 100%;
}
.headers .bannerNote {
    margin-left: 19.3%;
    margin-top: 99px;
    color: #D59D52;
		font-size: 48px;
		text-align: left;
		font-family: PingFangSC-medium;
    height: 100px;
}
.body_one{
	width: 100%;
	height: auto;
	background-color: #FFFFFF;
	display: flex;
	flex-direction: column;
	margin-top:24px;
}
.outerdiv{
	width: 1200px;
	margin: 0 auto;
}
.gray{
	background-color: #F8F8F8;
}
.heights{
	height: 600px;
}
.topdiv{
	width: 100%;
	height:30px;
	line-height: 30px;
	font-size: 24px;
	text-align: left;
	margin-top: 24px;
	font-family: SourceHanSansSC-regular;
	font-weight: bold;
	display: flex;
	justify-content: space-around;
}
.body_one_title{
	width: 84%;
	text-align: left;
}
.body_one_searchbox{
	width: 273px;
	height: 30px;
	display: flex;
	justify-content: flex-start;
}
.searchBox_l{
	width: 200px;
	height: 30px;
	border: 1px solid #DBDBDB;
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
	display: flex;
	justify-content: flex-start;
}
.searchBox_l_img{
	width: 20px;
	height: 30px;
	padding-left: 10px;
}
.searchBox_l_input{
	width: 200px;
	height: 30px;
}
 .pass_input {
            float: left;
            width: 97%;
            height: 30px;
            margin-bottom: 5px;
            & /deep/ .el-input__inner {
                    border: none;
                    width: 100%;
                    height: 25px;
                     padding: 0;
                     margin-left: 5px;
            }
    }
  .searchBox_r{
  	width: 54px;
  	height: 32px;
  	line-height: 32px;
  	background-color: #4393F5;
  	color: #FFFFFF;
  text-align: center;
  font-size: 12px;
  border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
	cursor: pointer;
  }  
.body_one_line{
	width: 100%;
	height: 3px;
	background-color: #000;
	margin-top: 24px;
}
	.navcolor {
		background: #3894FF;
		color: #FFFFFF;
}
.navcolors{
	background: #F8F8F8;
}
.body_one_navbox{
		width: 100%;
	  height: 98px;
	  margin: 0;
}
.body_one_navbox ul{
	width: 100%;
	height: 50px;
}
.body_one_navbox li{
	width: 120px;
	height: 50px;
	line-height: 50px;
	font-size: 14px;
	float: left;
	list-style: none;
	text-align: center;
	cursor: pointer;
	border-radius: 2px;
	margin-right: 4px;
	margin-left: 4px;
	margin-top: 24px;
	margin-bottom: 24px;
}
.body_one_listtable{
	width: 100%;
	height: auto;
	min-height: 300px;
	padding-bottom: 20px;
	margin-top: 24px;
}
.body_one_listtable_one {
    width: 100%;
    height: 100px;
    line-height: 100px;
    display: flex;
    justify-content: flex-start;
    margin-top: 24px;
    font-size: 30px;
    font-weight: bold;
    box-shadow: 0px 2px 11px 4px rgba(140, 140, 140, 0.1);
}
.body_one_listtable_one_l {
    width: 85%;
    height: 100px;
    line-height: 100px;
    text-align: left;
    margin-left: 24px;
}

.body_one_listtable_one_r {
    width: 15%;
   height: 100px;
    line-height: 100px;
    cursor: pointer;
    color: #D59D52;
}
.body_one_pageturn{
		width: 98%;
	height: 28px;
	line-height: 28px;
	font-size: 12px;
	text-align: right;
	margin-bottom: 24px;
	margin-top: 24px;
	margin-right: 2%;
}
.content{
	width: 100%;
	height: 300px;
	overflow: auto;
}
</style>
<style scoped>
.contentMap {
   width: 1200px;
   display: flex;
   flex-direction: column;
   margin: 0 auto;
   margin-top: 91px;


}

.contentMaptop {


   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: space-between;
}

.contentMaptopleft {
   color: rgba(51, 51, 51, 1);
   font-size: 32px;
   text-align: left;
   font-family: SourceHanSansSC-regular;
   font-weight: bold;
}

.contentMaptopright {
   width: 281px;
   height: 28px;
   background-image: url('../assets/title.png');
   background-repeat: no-repeat;
   background-size: 100% 100%;
}

.contentMaptopline {
   width: 100%;
   height: 2px;
   line-height: 20px;
   background-color: rgba(16, 16, 16, 1);
   text-align: center;
   margin-top: 16px;
}

.contentMapcontent {
   width: 1200px;
   height: 544px;

   background-color: rgba(255, 255, 255, 1);

   box-shadow: 0px 2px 11px 4px rgba(140, 140, 140, 0.1);
   display: flex;
   flex-direction: row;
   align-items: center;
   margin-top: 47px;
}

.contentMapcontentleft {
   width: 450px;
   height: 100%;
   /* border: 1px solid red; */
   display: flex;
   flex-direction: column;
}

.contentMapcontentlefttop {

   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: space-between;
   margin-top: 32px;
}

.contentMapcontentlefttoptitle {
   color: rgba(16, 16, 16, 1);
   font-size: 24px;
   text-align: left;
   font-family: SourceHanSansSC-medium;
   font-weight: bold;
   margin-left: 32px;
}

.contentMapcontentlefttopright {
   color: rgba(178, 178, 178, 1);
   font-size: 14px;
   text-align: left;
   font-family: SourceHanSansSC-regular;
   margin-right: 32px;
}

.contentMapcontentleftarr {
   width: 100%;
   display: flex;
   flex-direction: column;
   height: 544px;
   overflow: auto;
}

.contentMapcontentleftarrfor {

   width: 100%;
}

.contentMapcontentleftarrfortop {
   display: flex;
   flex-direction: row;
   align-items: center;
   margin-top: 44px;
   margin-left: 32px;
}

.contentMapcontentleftarrfortopindex {
   width: 20px;
   height: 20px;
   line-height: 20px;
   background-color: rgba(238, 21, 21, 1);
   color: rgba(255, 255, 255, 1);
   font-size: 12px;
   text-align: center;
   font-family: Roboto;
   border-radius: 50%;
}

.contentMapcontentleftarrfortopname {
   color: rgba(16, 16, 16, 1);
   font-size: 16px;
   text-align: left;
   font-family: SourceHanSansSC-regular;

   margin-left: 5px;
}

.contentMapcontentleftarrfortopaddress {
   display: flex;
   flex-direction: row;
   align-items: center;
   margin-top: 20px;
   margin-left: 32px;
}

.contentMapcontentleftarrfortopaddressleft {
   width: 20px;
   height: 20px;
   background-image: url('../assets/address.png');
   background-repeat: no-repeat;
   background-size: 100% 100%;
}

.listarrlefttoparrcontentaddressdetailaddressright {
   color: rgba(16, 16, 16, 1);
   font-size: 16px;
   text-align: left;
   font-family: SourceHanSansSC-regular;

   margin-left: 5px;
}

.contentMapcontentleftarrfortopphone {
   display: flex;
   flex-direction: row;
   align-items: center;
   margin-top: 15px;
   margin-left: 32px;
}

.contentMapcontentleftarrfortopphoneleft {
   width: 20px;
   height: 20px;
   background-image: url('../assets/phone.png');
   background-repeat: no-repeat;
   background-size: 100% 100%;
}

.contentMapcontentleftarrfortopphoneright {
   color: rgba(16, 16, 16, 1);
   font-size: 16px;
   text-align: left;
   font-family: SourceHanSansSC-regular;

   margin-left: 5px;
}

.contentMapcontentleftarrfortoptime {
   display: flex;
   flex-direction: row;
   align-items: center;
   margin-top: 15px;
   margin-left: 32px;
}

.contentMapcontentleftarrfortoptimeleft {
   width: 20px;
   height: 20px;
   background-image: url('../assets/time.png');
   background-repeat: no-repeat;
   background-size: 100% 100%;
}

.contentMapcontentleftarrfortoptimeright {
   color: rgba(16, 16, 16, 1);
   font-size: 16px;
   text-align: left;
   font-family: SourceHanSansSC-regular;

   margin-left: 5px;
}

.contentMapcontentleftarrforbottomline {
   width: 341px;
   height: NaNpx;
   border: 1px solid rgba(224, 224, 224, 1);
   margin: 0 auto;
   margin-top: 40px;
}

.contentMapcontentright {
   width: 763px;
   height: 481px;
   margin-left: 32px;
   margin-right: 32px;
}

/deep/.amap-icon img {
   width: 20px;
   height: 20px;
   position: relative;
   text-align: left;
   animation-name: imgsmalltobig;
   animation-duration: 0.8s;
   animation-iteration-count: infinite;
}

/deep/.amap-logo {
   display: none !important;
}

/deep/.amap-copyright {
   display: none !important;
}

.markercontent {
   width: 253px;
   height: 100px;
   background-image: url('../assets/market.png');
   background-repeat: no-repeat;
   background-size: 100% 100%;
   display: flex;
   flex-direction: column;
}

.markercontenttitle {
   display: flex;
   flex-direction: row;
   align-items: center;
   text-align: left;
}

.markercontenttitleleft {

   color: #FD4545;
   font-size: 12px
}

.markercontenttitlerighted {
   width: 30px;
   color: #A9A9AA;
   font-size: 12px;
   margin-left: 40px;
   margin-top: -10px;
}

.markercontenttitleright {
   width: 140px;
   font-size: 12px;
   margin-left: 5px;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}</style>
<style scoped>
.contentNew {
    width: 1200px;
    display: flex;
    flex-direction: column;

    margin: 0 auto;
		
		margin-top: 48px;

}

.contentNewtop {


    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.contentNewtoptopleft {
    color: rgba(51, 51, 51, 1);
    font-size: 32px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    font-weight: bold;
}

.contentNewtopright {
    width: 281px;
    height: 28px;
    background-image: url('../assets/title.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.contentNewtopline {
    width: 100%;
    height: 2px;
    line-height: 20px;
    background-color: rgba(16, 16, 16, 1);
    text-align: center;
    margin-top: 16px;
}

.contentNewcontent {
    width: 1200px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 11px 4px rgba(140, 140, 140, 0.1);
    display: flex;
    flex-direction: row;

}

/* 左侧 */
.contentNewcontentleft {
    display: flex;
    flex-direction: column;
    margin-top: 47px;

}

.contentNewcontentleftimg {
    width: 743px;
    height: 417px;
}

.contentNewcontentleftbottom {
    width: 743px;
    height: 214px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 11px 4px rgba(140, 140, 140, 0.1);
    display: flex;
    flex-direction: column;
}

.contentNewcontentleftbottomtop {
    display: flex;
    flex-direction: column;
}

.contentNewcontentleftbottomtoptitle {
    width: 720px;
    color: rgba(16, 16, 16, 1);
    font-size: 24px;
    text-align: left;
    font-family: SourceHanSansSC-bold;
    font-weight: bold;
    margin-top: 24px;
    margin-left: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.contentNewcontentleftbottomtoptitletwo {
    width: 695px;

    color: rgba(102, 102, 102, 1);
    font-size: 16px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    margin-top: 16px;
    margin-left: 24px;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;

    word-break: break-all;
    
    cursor: pointer;

}

.contentNewcontentleftbottomline {
    width: 695px;
    height: NaNpx;
    border: 1px solid rgba(224, 224, 224, 1);
    margin: 0 auto;
    margin-top: 24px;
}

.contentNewpcontentleftbottombottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
}

.contentNewcontentleftbottombottomleft {
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    margin-left: 24px;
}

.contentNewpcontentleftbottombottomright {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 20px;
}

.contentNewcontentleftbottombottomrightimg {
    width: 140px;
    height: 18px;
    background-image: url('../assets/blue.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.contentNewpcontentleftbottombottomrightimgtwo {
    width: 20px;
    height: 20px;
    background-image: url('../assets/newsright.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

/* 右侧 */
.contentNewcontentright {
    display: flex;
    flex-direction: column;
    margin-left: 24px;
    margin-top: 47px;


}

.contentNewpcontentrighttop {
    display: flex;
    flex-direction: column;
    align-items: center;
		min-height: 556px;
}

.contentNewpcontentrighttopfor {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 35px;
}

.contentNewcontentrighttopforleft {
    display: flex;
    flex-direction: column;
    align-items: center;

}

.contentNewcontentrighttopforleftdata {
    color: rgba(51, 51, 51, 1);
    font-size: 16px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
}

.contentNewcontentrighttopforleftdatayear {
    width: 50px;
    height: 25px;
    line-height: 25px;
    border-radius: 34px;
    background-color: rgba(255, 255, 255, 1);
    text-align: center;
    border: 1px solid rgba(153, 153, 153, 1);
    margin-top: 14px;
}

.contentNewcontentrighttopmiddleline {
    width: NaNpx;
    height: 82px;
    border-right: 1px solid rgba(187, 187, 187, 1);
    margin-left: 20px;
}

.contentNewcontentrighttopforright {
    display: flex;
    flex-direction: column;
    margin-left: 20px;

}

.contentNewcontentrighttopforrighttitle {
		width: 330px;
		color: rgba(16, 16, 16, 1);
		font-size: 18px;
		text-align: left;
		font-family: SourceHanSansSC-bold;
		font-weight: bold;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-right: 10px;
	}
	
	.contentNewcontentrighttopforrighttitletwo {
		width: 329px;
		color: rgba(102, 102, 102, 1);
		font-size: 16px;
		text-align: left;
		font-family: SourceHanSansSC-regular;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		white-space: normal;
		word-break: break-all;
		margin-top: 10px;
		cursor: pointer;
	}

.contentNewpcontentrighttopforline {
    width: 430px;
    height: NaNpx;
    border-bottom: 1px solid rgba(187, 187, 187, 1);
    margin-top: 20px;
}

.contentNewcontentrightturn {
    width: 430px;
    height: 47px;
    margin-top: 27px;
    background: #F8F8F8;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
<style scoped>
.contentCommit {
    width: 1200px;
    display: flex;
    flex-direction: column;
		margin: 0 auto;
		margin-top: 48px;
		margin-bottom: 48px;

}

.contentCommittop {


    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.contentCommittopleft {
    color: rgba(51, 51, 51, 1);
    font-size: 32px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    font-weight: bold;
}

.contentCommittopright {
    width: 281px;
    height: 28px;
    background-image: url('../assets/title.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.contentCommittoprighttopline {
    width: 100%;
    height: 2px;
    line-height: 20px;
    background-color: rgba(16, 16, 16, 1);
    text-align: center;
    margin-top: 16px;
}

.contentCommittcontent {
    width: 1200px;
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    flex-direction: row;
    justify-content: space-between;

}

.navelistlistarr {
    width: 380px !important;
    height: 307px;
    border-radius: 10px;
    /* border:  1px solid red; */
    margin-top: 30px;
    background-repeat: no-repeat;
    background-size: 100% 100%;



}



.navelistlistfortoptitle {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
    text-align: left;
    font-family: SourceHanSansSC-bold;
    font-weight: bold;
    margin-top: 24px;
    margin-left: 24px;
}

.navelistlistfortoptitled {
    width: 264px;
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
    text-align: left;
    font-family: SourceHanSansSC-bold;
    font-weight: bold;
    margin-top: 24px;
    margin-left: 24px;
}

.navelistlistfortoptitthree {
    width: 96px;
    height: 30px;
    line-height: 30px;
    border-radius: 29px;
    background-color: rgba(255, 255, 255, 1);
    text-align: center;
    color: #4293F4;
    margin-top: 50px;
    margin-left: 24px;
    cursor: pointer;
}
</style>
<style>
.el-message {
display: flex;
width: 380px;
height: 83px;
line-height: 20px;
border-radius: 4px;
background-color: rgba(237, 245, 255, 1);
text-align: center;
border: 1px solid rgb(67, 147, 245) !important;
align-items: flex-start !important;
}
.myicon{
width: 26px;
height: 26px;
background-image: url('../assets/mess.png');
background-repeat: no-repeat;
background-size: 100% 100%;
}
.el-message p{
margin-top: 5px !important;
}
	</style>

